import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Divider, ListItemIcon, ListItemText, Menu, MenuItem, Typography } from '@mui/material';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { PATH_DASHBOARD } from '../../routes/paths';
import { MIconButton } from '../../components/@material-extend';
import useLocales from '../../hooks/useLocales';
import { AddTopicDialog } from './AddTopicDialog';

export default function CreatePopover() {
  const { translate } = useLocales();
  const navigate = useNavigate();
  const [anchor, setAnchor] = useState<null | HTMLElement>(null);
  const [addTopicOpen, setAddTopicOpen] = useState(false);
  const open = Boolean(anchor);

  const handleClose = () => setAnchor(null);

  return (
    <>
      <MIconButton
        onClick={(e) => setAnchor(e.currentTarget)}
        color="default"
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 0.75,
          border: '1px solid',
          borderColor: open ? 'divider' : 'transparent',
          borderRadius: 1,
          '&:hover': {
            border: (theme) => `1px solid ${theme.palette.divider}`,
            backgroundColor: 'transparent'
          }
        }}
      >
        <Typography variant="subtitle2">{translate('overview.create')}</Typography>
        <KeyboardArrowDownIcon
          sx={{
            fontSize: 16,
            color: 'text.secondary',
            transform: open ? 'rotate(180deg)' : 'none',
            transition: 'transform 0.15s ease'
          }}
        />
      </MIconButton>

      <Menu
        anchorEl={anchor}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        PaperProps={{ sx: { mt: 1, minWidth: 220 } }}
      >
        <MenuItem
          onClick={() => {
            handleClose();
            setAddTopicOpen(true);
          }}
        >
          <ListItemIcon>
            <ArticleOutlinedIcon sx={{ fontSize: 20 }} />
          </ListItemIcon>
          <ListItemText
            primary={translate('overview.create_topic_label')}
            secondary={translate('overview.add_topic_subtitle')}
            primaryTypographyProps={{ variant: 'body2', fontWeight: 600 }}
            secondaryTypographyProps={{ variant: 'caption' }}
          />
        </MenuItem>

        <Divider sx={{ my: 0.5 }} />

        <MenuItem
          onClick={() => {
            handleClose();
            navigate(PATH_DASHBOARD.pathway.new);
          }}
        >
          <ListItemIcon>
            <AccountTreeOutlinedIcon sx={{ fontSize: 20 }} />
          </ListItemIcon>
          <ListItemText
            primary={translate('overview.create_pathway_label')}
            secondary={translate('overview.new_pathway_subtitle')}
            primaryTypographyProps={{ variant: 'body2' }}
            secondaryTypographyProps={{ variant: 'caption' }}
          />
        </MenuItem>
      </Menu>
      <AddTopicDialog open={addTopicOpen} onClose={() => setAddTopicOpen(false)} />
    </>
  );
}
